import { createFileRoute, Link } from '@tanstack/react-router';
import styled from 'styled-components';
import api from '@/api';
import { Field, FieldLabel, FieldValue } from '~/components/ui/FieldDisplay';
import { PageTitle } from '~/components/ui/Page';
import { FieldGrid, Section, SectionTitle } from '~/components/ui/Section';

export const Route = createFileRoute('/_admin/study-helpers/$studyHelperId')({
  component: StudyHelperDetail,
});

function StudyHelperDetail() {
  const { studyHelperId } = Route.useParams();

  const {
    data: helper,
    isLoading,
    error,
  } = api.getStudyHelper.useQuery({
    path: { study_helper_id: Number(studyHelperId) },
  });

  if (isLoading) {
    return <LoadingMessage>Loading study helper...</LoadingMessage>;
  }

  if (error) {
    return <ErrorMessage>Error loading study helper</ErrorMessage>;
  }

  if (!helper) {
    return <ErrorMessage>Study helper not found</ErrorMessage>;
  }

  return (
    <Container>
      <BackLink to="/study-helpers">&larr; Back to Study Helpers</BackLink>
      <PageTitle>
        {helper.display_name || `Study Helper ${studyHelperId}`}
      </PageTitle>

      <Section>
        <SectionTitle>Details</SectionTitle>
        <FieldGrid>
          <Field>
            <FieldLabel>ID</FieldLabel>
            <FieldValue>{helper.id}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Name</FieldLabel>
            <FieldValue>
              {`${helper.first_name} ${helper.last_name}`.trim() || '—'}
            </FieldValue>
          </Field>
          <Field>
            <FieldLabel>Email</FieldLabel>
            <FieldValue>{helper.email || '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Phone</FieldLabel>
            <FieldValue>{helper.phone || '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Language</FieldLabel>
            <FieldValue>{helper.language}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Country</FieldLabel>
            <FieldValue>{helper.country || '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>City</FieldLabel>
            <FieldValue>{helper.city || '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Suspended</FieldLabel>
            <FieldValue>{helper.suspended ? 'Yes' : 'No'}</FieldValue>
          </Field>
        </FieldGrid>
      </Section>

      <Section>
        <SectionTitle>Congregation</SectionTitle>
        <FieldGrid>
          <Field>
            <FieldLabel>Name</FieldLabel>
            <FieldValue>{helper.congregation_name || '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Country</FieldLabel>
            <FieldValue>{helper.congregation_country || '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>State</FieldLabel>
            <FieldValue>{helper.congregation_state || '—'}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>City</FieldLabel>
            <FieldValue>{helper.congregation_city || '—'}</FieldValue>
          </Field>
        </FieldGrid>
      </Section>
    </Container>
  );
}

const Container = styled.div``;

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--blue);
  text-decoration: none;
  margin-bottom: 1rem;
  font-size: 0.875rem;

  &:hover {
    text-decoration: underline;
  }
`;

const LoadingMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: var(--grey-600);
`;

const ErrorMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: var(--error);
`;
